var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/closeContent.67609e5b.png","uri@2x": __webpack_public_path__ + "static/media/closeContent.00637779.png","uri@3x": __webpack_public_path__ + "static/media/closeContent.1b1d0597.png",
    width: 16,
    height: 16
});